import { createContext } from "react";

const LinesContext = createContext();

export default LinesContext;
